<template>
  <div>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>
<!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>-->
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th>說明</th>
        <th>設定值</th>
        <th class="text-center">功能</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">

        <td width="120px">
          {{item.Name}}
        </td>
        <td >
          <div v-if="item.Type==='img'">
            <img :src="convertToRealUrl(item.Value)" style="width: 400px;">
            <FileUploadButton :emmit-back-param="item" v-on:uploadSuccess="uploadSuccess" :file-type="'specifyFile'" :specify-file-name-path="item.Value"></FileUploadButton>
            {{item.Memo}}
          </div>
          <div v-else-if="item.Type==='html'">
            <pre>
              {{item.Value}}
              {{item.Memo}}
            </pre>
          </div>
          <div v-else-if="item.Type==='text'">
            <p>
              <input type="text" class="form-control" placeholder="" v-model="item.Value">

              {{item.Memo}}
            </p>
          </div>
          <div v-else-if="item.Type==='textArea'">
            <p>
              <textarea class="form-control" rows="3" v-model="item.Value"></textarea>

              {{item.Memo}}
            </p>
          </div>
        </td>
<!--        <td class="text-center">-->
<!--          &lt;!&ndash;          <a class="btn btn-primary" @click="DataItem_Insert(item)"><i class="fas fa-plus-circle"></i></a>&ndash;&gt;-->
<!--          &lt;!&ndash;          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="far fa-trash-alt"></i></a>&ndash;&gt;-->
<!--          &lt;!&ndash;          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i> </a>&ndash;&gt;-->
<!--          &lt;!&ndash;          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i> </a>&ndash;&gt;-->
<!--          <a class="btn btn-primary" href="#"><i class="fa fa-save"></i></a>-->
<!--        </td>-->
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


import Vue from "vue";
import FileUploadButton from "@/views/taylorAdmin/component/FileUploadButton";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import {
  QueryType_Setting
} from "./js/rotaryDeclare";

export default {
  components: {FileUploadButton},
  //name: "setting",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{

      },
      datasDemo:[
        {
          SystemId:"",
          Name:"網站名稱",
          Type:"text",
          Value:"台北建成扶輪社",

        },
        {
          SystemId:"",
          Name:"網站背景圖",
          Type:"img",
          Value:"/images/index/bg.jpg",
          Memo:"建議大小1920x788",
        },
        {
          SystemId:"",
          Name:"頁首Logo",
          Type:"img",
          Value:"/images/logo.png",
          Memo:"建議大小675x80",
        },
        {
          SystemId:"",
          Name:"頁尾Logo",
          Type:"img",
          Value:"/images/index/footer_bg.jpg",
          Memo:"建議大小1542x274",
        },
      ],
      QueryType_Setting:QueryType_Setting,
    };
  },
  methods: {
    loadData() {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;
      apiAdmin.api_getContent(QueryType_Setting).then((data)=>{
        let dataApi=apiAdmin.init(data.data.data);
        that.datas=dataApi;
      })
    },
    submit(){
      apiAdmin.api_saveContent(QueryType_Setting,this.datas).then((data)=>{
        console.log(data);
        alert('儲存成功')
      })
    },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    uploadSuccess(image,result){
      if (result && result.data.FileCount>0){
        image.Value=result.data.FileUrls[0] +"?a="+Math.random();
      }else{
        alert("檔案上傳失敗")
      }
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
